import GoogleCampaignGrid from '../../google/google-campaigns';

const ViMarcGoogleCampaignGrid = (props) => (
    <GoogleCampaignGrid
        {...props}
        vimarcMode={true}
        retailMode={true}
    />
);

export default ViMarcGoogleCampaignGrid;
